import React, { useContext } from "react";
import { Context } from "../../../Context";
import {
  ConfigurationPlanRenovationView,
  PlanPricingView,
  ContractView,
  PaymentProcessView,
  ResumeView,
} from "../../views";
import { ValidateInputPure, SimpleLoading } from "../../pures";
import {
  LocalStorageService,
  UserService,
  PlanService,
  ContractService,
  PaymentTypeService,
} from "../../../services";
import { DOMUtil } from "../../../utils";
import { RegistrationValidator } from "../../../validators";
import AOS from "aos";
import {
  Pricing,
  TermsCondition,
  PaymentProcess,
  Resume,
} from "../../../assets/logos/icons";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import moment from "moment";
import "moment/locale/es";
import scriptLoader from "react-async-script-loader";

class ConfigurationPlanRenovationAction extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    topScroll: true,
    dataItem: {},
    selectedStep: 0,
    planChecked: false,
    termnsAndConditions: false,
    contractCreated: false,
    folio: "",
    selectedPlanPricing: true,
    selectedPlanPricingId: [],
    selectedPlanLevel: {},
    changedTranslates: false,
    showNotificationAlert: false,
    loading: true,
    plan: [],
    contractBullets: [],
    warning: false,
    allPlan: [],
    showNotification: false,
    message: "Ocurrio un error",
    planStandard: "",
    planEstandarSelectPrice: "$0.00",
    planProSelectPrice: "$0.00",
    classSelectPackageStandar: "",
    classSelectPackagePro: "",
    messageTransfer: false,
    paymentType: [],
    dateResume: "",
    transfer: false,
    card: false,
    a3Direct: false,
    firstName: "",
    firstLastName: "",
    secondLastName: "",
    rfc: "",
    cellphoneNumber: "",
    createdContractRenewal: [],
    priceContractRenewal: "",

    avaliablePlans: [],
    assignedPlans: [],
    assignedPackage: [],

    total: 0,
    iva: 0,
    subtotal: 0,

    configurationRenovationSteps: [
      {
        icon: Pricing,
        itemElement: this.props.t("registration.action.plansAndPricing"),
        itemSup: this.props.t("registration.action.Steps.nextLaber"),
        key: "register.plan",
        labelreturn: this.props.t("registration.action.Steps.backLaber"),
        label: this.props.t("registration.action.plansAndPricing"),
      },
      {
        icon: TermsCondition,
        itemElement: this.props.t("registration.action.tos"),
        itemSup: this.props.t("registration.action.Steps.nextLaber"),
        key: this.props.t("registration.action.Steps.backLaber"),
        labelreturn: this.props.t("registration.action.Steps.backLaber"),
        label: this.props.t("registration.action.tos"),
      },
      {
        icon: PaymentProcess,
        itemElement: this.props.t("registration.action.payment"),
        itemSup: this.props.t("registration.action.Steps.nextPayment"),
        key: this.props.t("registration.action.payment"),
        labelreturn: this.props.t("registration.action.Steps.backLaber"),
        label: this.props.t("registration.action.payment"),
      },
      {
        icon: Resume,
        itemElement: this.props.t("registration.action.resume"),
        itemSup: "Ir a la aplicación",
        key: this.props.t("registration.action.resume"),
        labelreturn: this.props.t("registration.action.Steps.backLaber"),
        label: this.props.t("registration.action.resume"),
      },
    ],
  };

  notification = {
    type: {
      style: "error",
      icon: true,
    },
    style: {
      top: 760,
      right: 20,
      position: "absolute",
    },
  };

  token = {};
  user = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  userService = new UserService(this.url);
  planService = new PlanService(this.url);
  contractService = new ContractService(this.url);
  localStorageService = new LocalStorageService();
  domUtil = new DOMUtil();
  validator = RegistrationValidator(this.props.t);
  paymentTypeService = new PaymentTypeService(this.url);

  configurationStepMetadata = [
    { number: 0, component: PlanPricingView, action: "validatePlan" },
    { number: 1, component: ContractView, action: "validateContract" },
    {
      number: 2,
      component: PaymentProcessView,
      action: "validatePaymentMethod",
    },
    { number: 3, component: ResumeView },
  ];

  formatter = new Intl.NumberFormat(
    "en-MX",
    { style: "currency", currency: "MXN", currencyDisplay: "narrowSymbol" },
    {
      style: "currency",
      currency: "MXN",
    }
  );

  /**
   * @author Leonel Contreras
   * @description Change the state to select terms and conditions
   */
  onAcceptTermnsAndConditions = () =>
    this.setState({ termnsAndConditions: !this.state.termnsAndConditions });

  /**
   * @author Leonel Contreras
   * @description Change the state to select plan
   */
  onAcceptPlan = () => this.setState({ planChecked: !this.state.planChecked });

  /**
   * @author Leonel Contreras
   * @description Close/Open the modal
   */
  onCloseOpenModal = () =>
    this.setState({ showNotification: !this.state.showNotification });

  onChangeValue = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };
  /**
   * @author Lucia Alvarado
   * @description Change the state to select card
   */
  onAcceptCard = (event) => {
    this.setState({
      card: event ? event.value : !this.state.card,
      transfer: false,
      a3Direct: false,
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Change the state to select transfer
   */
  onAcceptTransfer = () => {
    this.setState({
      card: false,
      transfer: !this.state.transfer,
      a3Direct: false,
    });
  };

  onAcceptA3Direct = () => {
    this.setState({
      card: false,
      a3Direct: !this.state.a3Direct,
      transfer: false,
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Change the state to select message of transfer
   */
  onAcceptMessageTransfer = () =>
    this.setState({ messageTransfer: !this.state.messageTransfer });

  /**
   * @author Lucia Alvarado
   * @description Accept read message of transfer
   */
  onAcceptTransferMessage = () =>
    this.setState({ transferMessage: !this.state.transferMessage });

  /**
   * @author Leonel Contreras
   * Match the features array to allFeatures array and
   * check the set that it has
   * @param {Object[]} allFeatures
   * @param {object[]} features
   */
  planCheckFeature = (allFeatures, features) => {
    let result = [];
    if (typeof features[0].feature.name != "boolean") {
      for (let i = 0; i < allFeatures.length; i++) {
        const element = allFeatures[i].feature.name;
        let finding = {
          feature: {
            name: false,
          },
        };
        for (let j = 0; j < features.length; j++) {
          if (element === features[j].feature.name) {
            finding.feature.name = true;
          }
        }
        result.push(finding);
      }

      return result;
    } else {
      return features;
    }
  };

  /**
   * @author Leonel Contreras
   * @description sum all the features array
   * @param {Object} plan
   */
  getAllPlans = (plan) => {
    let allPlans = [];

    for (let i = 0; i < plan.length; i++) {
      const element = plan[i];

      for (let j = 0; j < element.planFeatures.length; j++) {
        const feature = element.planFeatures[j].feature.name;
        if (allPlans.indexOf(feature) === -1) allPlans.push(feature);
      }
    }

    allPlans = allPlans.map((plan) => {
      return {
        feature: {
          name: plan,
        },
      };
    });
    return allPlans;
  };

  onSelectPlan = () => {
    this.setState({
      card: true,
      transfer: false,
      a3Direct: false,
    })
  }
  // onSelectPlan = (event, plan) => {
  //   event.preventDefault()
  //   let selectedPlanPricingId = plan.id
  //   let card = true
  //   let a3Direct = false
  //   let transfer = false

  //   if (plan.id === Number(process.env.REACT_APP_PLAN_STANDAR_PLUS)) {
  //     card = false
  //     a3Direct = true
  //   }

  //   this.setState({
  //     selectedPlanPricing: true,
  //     card,
  //     a3Direct,
  //     transfer,
  //     selectedPlanPricingId,
  //     selectedPlanLevel: plan,
  //     planProSelectPrice: plan.pricing,
  //     planEstandarSelectPrice: "$0.00",
  //     classSelectPackagePro: "plan-item-button-active",
  //     classSelectPackageStandar: "",
  //   })
  // }

  /**
   * @author Leonel Contreras
   * @description determine the step number
   * @param {Number} step
   */
  changeStepNumber = (step) => {
    let stepLenght = this.state.configurationRenovationSteps.length - 1;
    step = step >= stepLenght ? stepLenght : step + 1;
    return step;
  };

  /**
   * @author Leonel Contreras
   * @description Check if is necesary update the translates
   * @param {Object[]} steps
   * @param {Function} t
   */
  changeTranslates = (steps, t, i18n) => {
    if (!this.state.changedTranslates && i18n.language !== "es-MX") {
      let translates = this.getTranslates(steps, t);

      for (let i = 0; i < steps.length; i++) {
        const step = steps[i];

        for (let j = 0; j < translates.length; j++) {
          const translate = translates[j];

          if (step.key === translate.key) {
            step.label = translate.value;
          }
        }
      }
      return this.setState({ steps, changedTranslates: true });
    }
  };

  /**
   * @author Leonel Contreras
   * @description Get the required translates
   * @param {Object[]} steps
   * @param {Function} t
   */
  getTranslates = (steps, t) => {
    let translates = [];

    steps.forEach((step) => {
      let translate = t(step.key);
      translates.push({ key: step.key, value: translate });
    });

    return translates;
  };

  /**
   * @author Leonel Contreras
   * @description subtract one to step or returned to select person type
   * if step is zero
   * @param {number} step
   */
  stepBack = (step) => {
    if (this.state.preload && step === 0) {
      this.props.history.push("/configuration");
    } else if (step === 0) {
      // this.setState({selectedPlanPricing: true})
    } else {
      step = step - 1;
    }
    return step;
  };

  /**
   * @author Leonel Contreras
   * @description Change the state when click return button in stepper
   * @param {Event} event
   */
  onBackStep = async (event) => {
    event.preventDefault();
    let stepNumber = this.stepBack(this.state.selectedStep);
    this.setState({ selectedStep: stepNumber });
    window.scrollTo(0, 0);
  };

  /**
   * @author Leonel Contreras
   * @description Check if the plan is selected
   */
  validatePlan = () => {
    if (!(this.state.assignedPlans[0] || this.state.assignedPackage[0])) {
      this.setState({
        showWarningRequesting: true,
        message: this.props.t("registration.action.pleaseSelect"),
      });
      return false;
    } else {
      return true;
    }
  };

  toggleDialog = (message = "") =>
    this.setState({
      showNotificationAlert: !this.state.showNotificationAlert,
      message,
    });

  /**
   * @author Alan Aguilar
   * @description Method to show the WARNING dialog modal
   * @memberof SignatureRequestAction
   */
  toggleWarningRequesting = (value) => {
    this.setState({
      showWarningRequesting: value,
    });
  };

  /**
   * @author Leonel Contreras
   * @description Check if the contract is selected
   */
  validateContract = () => {
    if (!this.state.termnsAndConditions) {
      this.setState({
        showWarningRequesting: true,
        message: this.props.t("registration.action.pleaseTos"),
      });
      return false;
    } else if (!this.state.planChecked) {
      this.setState({
        showWarningRequesting: true,
        message: this.props.t("registration.action.pleaseConfirm"),
      });
      return false;
    } else {
      return true;
    }
  };

  validatePaymentMethod = () => {
    if (this.state.transfer || this.state.card || this.state.a3Direct) {
      if (this.state.transfer) {
        if (this.state.messageTransfer) {
          return true;
        } else {
          this.setState({
            showWarningRequesting: true,
            message: this.props.t("registration.action.acceptTransferMessage"),
          });
          return false;
        }
      } else if (this.state.card) {
        var creditCardDate = moment(this.state.expirationDate, "MM/YY");
        var today = moment();
        if (
          creditCardDate.isValid() &&
          today <= creditCardDate.add(1, "months")
        ) {
          return true;
        } else {
          this.setState({
            showWarningRequesting: true,
            message: "Al parecer la tarjeta a expirado, Inténtalo nuevamente.",
          });
          return false;
        }
      } else if (this.state.a3Direct) {
        return true;
      } else {
        return false;
      }
    } else {
      this.setState({
        showWarningRequesting: true,
        message: this.props.t("registration.action.selectPaymentType"),
      });
      return false;
    }
  };

  /**
   * @author Leonel Contreras
   * @description Close the modal after some time
   */
  handleMessage = () => {
    setTimeout(() => {
      this.onCloseOpenModal();
    }, 15000);
  };

  /**
   * @author Lucia Alvarado
   * @description Method to save form of the dialog
   * @param {Event} event
   * @memberof SignatureRequestAction
   */
  handleSubmit = (event) => {
    event.preventDefault();
    this.onSubmit();
    this.setState({ disableSignerButton: true });
  };

  /**
   * @author  Lucia Alvarado
   * @description Method to move scroll
   * @memberof ConfigurationSignatureHistoryDetailAction
   */
  scrollWindow = () => {
    window.scrollTo(0, 0);
  };

  /**
   * @author Leonel Contreras
   * @description Handle the submit event
   * @param {Object} dataItem
   */
  onSubmit = async (dataItem) => {
    let selectedStep = this.state.selectedStep;
    let stepNumber = this.changeStepNumber(selectedStep);
    let action = this.configurationStepMetadata[selectedStep].action;
    let result = true;

    if (this.state.contractCreated) {
      return this.setState({ selectedStep: stepNumber, isLastStep: true });
    }

    if (action) {
      result = this[action](dataItem);
    }

    if (
      selectedStep ===
      Number(process.env.REACT_APP_PLAN_RENEWAL_STEP_SELECT_PRICE) &&
      result
    ) {
      let planPricing = [];

      if (this.state.assignedPlans[0]) {
        planPricing.push(this.state.assignedPlans[0].id);
      }
      if (this.state.assignedPackage[0]) {
        planPricing.push(this.state.assignedPackage[0].id);
      }

      this.setState({
        selectedPlanPricingId: planPricing,
      });
    }

    if (
      selectedStep === Number(process.env.REACT_APP_PLAN_RENEWAL_STEP) &&
      result
    ) {
      let token = this.localStorageService.getLocalStorageItem("token");

      if (token) {
        this.token = token.idToken;
      } else {
        window.location.hash = "";
      }

      this.setState({ loading: true });
      window.scrollTo(0, 0);
      let newDataItem = {};

      newDataItem.paymentTypeId = this.state.card
        ? 1
        : this.state.transfer
          ? 2
          : 3;
      newDataItem.planLevelsId = this.state.selectedPlanPricingId;
      newDataItem.termAndConditionsAccept = this.state.termnsAndConditions;
      newDataItem.planSelectedAccept = this.state.planChecked;
      newDataItem.totalPrice = this.state.planEstandarSelectPrice;

      if (this.state.card) {
        let date = this.state.expirationDate.split("/");

        newDataItem.cardName = dataItem.cardName;

        window.OpenPay.setId(process.env.REACT_APP_ID);
        window.OpenPay.setApiKey(process.env.REACT_APP_API);
        window.OpenPay.setSandboxMode(
          process.env.REACT_APP_OPENPAY_SANDBOX === "true" ? true : false
        );

        newDataItem.deviceSessionId = window.OpenPay.deviceData.setup();

        window.OpenPay.token.create(
          {
            card_number: this.state.creditCard.split("-").join(""),
            holder_name: newDataItem.cardName,
            expiration_year: date[1],
            expiration_month: date[0],
            cvv2: dataItem.securityCode,
          },
          async (token) => {
            newDataItem.deviceToken = token.data.id;
            await this.createContract(newDataItem, this.token);
          },
          (error) => {
            this.showError(error);
            return false;
          }
        );
      } else if (this.state.transfer) {
        await this.createContract(newDataItem, this.token);
      } else if (this.state.a3Direct) {
        await this.createContract(newDataItem, this.token);
      }
    } else if (result) {
      this.setState({ selectedStep: stepNumber });
      window.scrollTo(0, 0);
    }
  };

  showError = (error) => {
    console.error("error", error);
    this.setState({
      contract: {},
      loading: false,
      contractCreatedError: true,
      attempOfPayment: true,
      expirationDate: "",
    });

    setTimeout(() => {
      this.setState({ contractCreatedError: false });
    }, 10000);
  };

  createContract = async (data, token) => {
    let contract = await this.contractService.createContractRenewal(
      data,
      token
    );

    try {
      if (contract.statusCode === 200) {
        if (this.state.transfer === true) {
          this.setState({
            createdContractRenewal: contract.data,
            priceContractRenewal: this.formatter.format(
              contract.data.bankcharge.amount
            ),
            loading: false,
            contractCreated: true,
            folio: contract.data.id,
          });
        } else if (this.state.card) {
          this.localStorageService.setLocalStorageItem(
            "chargeId",
            contract.data
          );
          // this.localStorageService.setLocalStorageItem("chargeURL", contract.data.url)
          window.location.replace(contract.data.url);
        } else {
          this.setState({
            creactedContract: contract.data.contracts[0],
            priceContractRenewal: this.formatter.format(
              contract.data.contracts[0].pricing
            ),
            loading: false,
            contractCreated: true,
            folio: contract.data.contracts[0].id,
          });
        }
      } else {
        this.showError();
        return false;
      }
    } catch (error) {
      this.showError();
      return false;
    }
  };

  goToApp = () => {
    this.props.history.push("/configuration");
    window.scrollTo(0, 0);
  };

  componentDidMount = async () => {
    this.user = this.localStorageService.getLocalStorageItem("user");
    let token = this.localStorageService.getLocalStorageItem("token");
    // let planSelected = this.localStorageService.getLocalStorageItem('plan-selected')
    let chargeId = this.localStorageService.getLocalStorageItem("chargeId");
    // let chargeURL = this.localStorageService.getLocalStorageItem("chargeURL");

    // if (!planSelected) {
    //   this.localStorageService.setLocalStorageItem('plan-selected', Number(process.env.REACT_APP_PLAN_STANDAR_BASIC))
    // }

    moment.locale("es");
    const { firstName, firstLastName, secondLastName, rfc, cellphoneNumber } =
      this.user.userMetaData.userA3Cloud;

    if (token) {
      this.token = token.idToken;
    } else {
      window.location.hash = "";
    }

    let plan = await this.planService.getPlanService(this.token);
    let contractBullets = await this.contractService.getContractBullets(
      this.token
    );
    let allPlan = this.getAllPlans(plan);

    let dateResumeStart = new Date();
    let dateFormatResume = moment(dateResumeStart).format("DD/MMMM/YYYY");
    let paymentType = await this.paymentTypeService.getPaymentType(this.token);
    // let selectedPlanPricingId
    // let selectedPlanLevel
    // let planProSelectPrice
    // let planStandardPlus
    let card = true;
    let a3Direct = false;

    // plan.map((plan) => {
    //   plan.planLevels = plan.planLevels.map((planLevel) => {
    //     planLevel.originalPrice = planLevel.pricing
    // planLevel.pricing = formatter.format(planLevel.pricing)

    //     if (planLevel.id === Number(process.env.REACT_APP_PLAN_STANDAR_BASIC)) {
    //       selectedPlanPricingId = planLevel.id
    //       selectedPlanLevel = planLevel
    //       planProSelectPrice = planLevel.pricing
    //     }

    //     if ((planLevel.id === planSelected) && chargeId && chargeURL) {
    //       selectedPlanPricingId = planLevel.id
    //       selectedPlanLevel = planLevel
    //       planProSelectPrice = planLevel.pricing
    //     }

    //     if (planLevel.id === Number(process.env.REACT_APP_PLAN_STANDAR_PLUS)) {
    //       planStandardPlus = planLevel
    //     }

    //     return planLevel
    //   })

    //   return plan
    // })

    let allPlanLevels = [];
    plan.forEach((element) => {
      element.planLevels.forEach((planLevel) => {
        planLevel.originalPrice = planLevel.pricing;
        planLevel.pricing = this.formatter.format(planLevel.pricing);
        allPlanLevels.push(planLevel);
        if (chargeId) {
          chargeId.contracts.map((contract) => {
            let plan = [];
            if (contract.planLevelId === planLevel.id) {
              if (planLevel.planId === 1) {
                plan.push(planLevel);
                this.setState({
                  ///total, subtotal, iva,
                  assignedPackage: plan,
                });
              }
              if (planLevel.planId === 3) {
                plan.push(planLevel);
                this.setState({
                  assignedPlans: plan,
                });
              }
              this.updatePricing();
            }
          });
        }
      });
    });

    // if (Number(planSelected) === Number(process.env.REACT_APP_PLAN_STANDAR_PLUS)) {
    //   selectedPlanPricingId = planStandardPlus.id
    //   selectedPlanLevel = planStandardPlus
    //   planProSelectPrice = planStandardPlus.pricing
    //   card = false
    //   a3Direct = true
    // }

    try {
      this.setState({
        preload: true,
        planStandard: plan[0].name,
        // selectedPlanPricingId,
        // selectedPlanLevel,
        // planProSelectPrice,
        card,
        a3Direct,
        plan: plan,
        allPlan: allPlan,
        dateResume: dateFormatResume,
        paymentType: paymentType,
        user: this.user,
        firstName,
        firstLastName,
        secondLastName,
        rfc,
        cellphoneNumber,
        avaliablePlans: allPlanLevels,
      });

      // if (chargeId && chargeURL) {
      if (chargeId) {
        await this.verifyContract(chargeId, this.token);
      }
      // Animation view
      AOS.init({
        duration: 1000,
      });

      return this.setState({
        plan,
        allPlan,
        contractBullets,
        reload: true,
        loading: false,
      });
    } catch (error) {
      this.props.history.push("/");
      this.props.setShowError(true);
      return;
    }
  };

  verifyContract = async (data, token) => {
    let contract = await this.contractService.contractVerify(data, token);
    this.localStorageService.deleteElementLocalStorage("chargeId");
    // this.localStorageService.deleteElementLocalStorage("chargeURL")

    this.setState({
      selectedStep: 2,
      loading: false,
      termnsAndConditions: true,
      planChecked: true,
    });

    try {
      if (contract.statusCode === 200) {
        this.setState({
          contractCreated: true,
          folio: contract.data.contracts.id,
          creditCard: contract.data.creditCard,
        });
      } else {
        this.showError();
        return false;
      }
    } catch (error) {
      this.showError();
      return false;
    }
  };

  componentDidUpdate = async () => {
    let node = this.domUtil.findDomElementByClassAndProperty(
      "plan-item-button",
      "id",
      this.state.selectedPlanPricingId
    );

    if (node) {
      this.domUtil.addCssClassToDOMNode(node, "plan-item-button-active");
    }
  };

  updatePricing = () => {
    //Precio con Iva
    let totalPriceSub = 0;
    if (this.state.assignedPlans[0]) {
      totalPriceSub =
        totalPriceSub + Number(this.state.assignedPlans[0].originalPrice);
    }
    if (this.state.assignedPackage[0]) {
      totalPriceSub =
        totalPriceSub + Number(this.state.assignedPackage[0].originalPrice);
    }
    let totalPriceIva = totalPriceSub * 0.16;
    let totalPlanPricing = totalPriceSub + totalPriceIva;

    let totalPrice = this.formatter.format(totalPlanPricing);
    totalPriceSub = this.formatter.format(totalPriceSub);
    totalPriceIva = this.formatter.format(totalPriceIva);
    this.setState({
      planEstandarSelectPrice: totalPlanPricing,
      total: totalPrice,
      subtotal: totalPriceSub,
      iva: totalPriceIva,
    });
  };

  updateAvaliablePlans = (avaliablePlans) => {
    avaliablePlans.sort(function (a, b) {
      if (a.order > b.order) {
        return 1;
      }
      if (a.order < b.order) {
        return -1;
      }
      return 0;
    });

    return avaliablePlans;
  };

  onClickAvaliablePlans = (id, plan, event) => {
    event.preventDefault();
    this.onSelectPlan()
    let avaliablePlans = this.state.avaliablePlans;
    let assignedPlans = this.state.assignedPlans;
    let assignedPackage = this.state.assignedPackage;

    if (assignedPackage[0]) {
      if (plan.id === 8) {
        avaliablePlans.push(assignedPackage[0]);
        assignedPackage.splice(0, 1);
      }
    }

    if (assignedPlans[0]) {
      avaliablePlans.push(assignedPlans[0]);
      assignedPlans.splice(0, 1);
    }

    if (plan.id === 8) {
      this.setState({
        card: false,
        transfer: false,
        a3Direct: true,
      });
    }

    avaliablePlans.splice(id, 1);
    assignedPlans.push(plan);

    avaliablePlans = this.updateAvaliablePlans(avaliablePlans);

    this.setState({
      avaliablePlans: avaliablePlans,
      assignedPlans: assignedPlans,
    });
    this.updatePricing();
  };

  onClickAvaliablePackage = (id, plan, event) => {
    event.preventDefault();
    this.onSelectPlan()
    let avaliablePlans = this.state.avaliablePlans;
    let assignedPackage = this.state.assignedPackage;
    let assignedPlans = this.state.assignedPlans;

    if (assignedPackage[0]) {
      avaliablePlans.push(assignedPackage[0]);
      assignedPackage.splice(0, 1);
    }

    if (assignedPlans[0]) {
      if (assignedPlans[0].id === 8) {
        avaliablePlans.push(assignedPlans[0]);
        assignedPlans.splice(0, 1);
      }
    }

    avaliablePlans.splice(id, 1);
    assignedPackage.push(plan);

    avaliablePlans = this.updateAvaliablePlans(avaliablePlans);

    this.setState({
      avaliablePlans: avaliablePlans,
      assignedPackage: assignedPackage,
    });
    this.updatePricing();
  };

  onClickAssignedPlan = (event) => {
    event.preventDefault();
    let avaliablePlans = this.state.avaliablePlans;
    let assignedPlans = this.state.assignedPlans;

    avaliablePlans.push(assignedPlans[0]);
    assignedPlans.splice(0, 1);

    avaliablePlans = this.updateAvaliablePlans(avaliablePlans);

    this.setState({
      avaliablePlans: avaliablePlans,
      assignedPlans: assignedPlans,
    });
    this.updatePricing();
  };

  onClickAssignedPackage = (event) => {
    event.preventDefault();
    let avaliablePlans = this.state.avaliablePlans;
    let assignedPackage = this.state.assignedPackage;

    avaliablePlans.push(assignedPackage[0]);
    assignedPackage.splice(0, 1);

    avaliablePlans = this.updateAvaliablePlans(avaliablePlans);

    this.setState({
      avaliablePlans: avaliablePlans,
      assignedPackage: assignedPackage,
    });
    this.updatePricing();
  };

  render = () => {

    return (
      <ConfigurationPlanRenovationView
        {...this.state}
        validateContract={this.validateContract}
        toggleDialog={this.toggleDialog}
        toggleWarningRequesting={this.toggleWarningRequesting}
        validateInput={ValidateInputPure}
        stepMetadata={this.configurationStepMetadata}
        steps={this.state.configurationRenovationSteps}
        notification={this.notification}
        validator={this.validator}
        onCloseOpenModal={this.onCloseOpenModal}
        getTranslates={this.getTranslates}
        changeTranslates={this.changeTranslates}
        onSubmitClick={this.onSubmitClick}
        onSubmit={this.onSubmit}
        onBackStep={this.onBackStep}
        goToApp={this.goToApp}
        planCheckFeature={this.planCheckFeature}
        onSelectPlanLevel={this.onSelectPlanLevel}
        onSelectPlanPaquet={this.onSelectPlanPaquet}
        onChangeValue={this.onChangeValue}
        onAcceptTermnsAndConditions={this.onAcceptTermnsAndConditions}
        onAcceptPlan={this.onAcceptPlan}
        principal={this.personType}
        warning={this.state.warning}
        handleWarning={this.handleWarning}
        handleSubmit={this.handleSubmit}
        fromPage={
          this.props.history.location.state &&
          this.props.history.location.state.fromPage
        }
        onAcceptCard={this.onAcceptCard}
        onAcceptTransfer={this.onAcceptTransfer}
        onAcceptA3Direct={this.onAcceptA3Direct}
        onAcceptMessageTransfer={this.onAcceptMessageTransfer}
        onClickAvaliablePlans={this.onClickAvaliablePlans}
        onClickAvaliablePackage={this.onClickAvaliablePackage}
        onClickAssignedPlan={this.onClickAssignedPlan}
        onClickAssignedPackage={this.onClickAssignedPackage}
      />
    );
  }
};


function ConfigurationPlanRenovationActionContainer(props) {
  const { t } = useTranslation();
  const { setShowError } = useContext(Context);
  return (
    <ConfigurationPlanRenovationAction
      {...props}
      t={t}
      setShowError={setShowError}
    />
  );
}

export default scriptLoader([
  "https://ajax.googleapis.com/ajax/libs/jquery/1.11.0/jquery.min.js",
  "https://js.openpay.mx/openpay.v1.min.js",
  "https://js.openpay.mx/openpay-data.v1.min.js",
])(ConfigurationPlanRenovationActionContainer);
